export default __webpack_public_path__ + "static/media/document-icon.ec179bc0.png";